import { AccessIntermediaryViewModel } from 'bff';
import { Search } from '@sanlam-glacier/app-common/components';
import { useState } from 'react';
import { ProfileExpandingMenu } from '../profile-expanding-menu/ProfileExpandingMenu';
import { SearchResultHeader } from '../search-result-header/SearchResultHeader';
import { UserContextCard } from '../user-context-card/UserContextCard';
import { Block, Grid } from '@sanlam-glacier/app-common/modules/grid';
import styles from '../../TopBar.module.scss';

interface UserSelectMenuProps {
  users: AccessIntermediaryViewModel[];
  isLoading: boolean;
  selectedUserIntermediaryCode?: string;
  setSelectedUser: (user: AccessIntermediaryViewModel) => void;
}

export const UserSelectMenu = ({
  users,
  isLoading,
  selectedUserIntermediaryCode,
  setSelectedUser
}: UserSelectMenuProps) => {
  const [actingAsSearchOpen, setActingAsSearchOpen] = useState<boolean>(false);
  const [userSearchTerm, setUserSearchTerm] = useState<string>();

  const isSelected = (user: AccessIntermediaryViewModel) =>
    user.intermediaryCode === selectedUserIntermediaryCode;

  const getSearchedUsers = (): AccessIntermediaryViewModel[] => {
    if (!userSearchTerm) return users;
    const searchedIntermediaries = users.filter((user) => {
      const lowerCaseFirstName = user.firstName?.toLocaleLowerCase();
      const lowerCaseSurname = user.lastName?.toLocaleLowerCase();
      const lowerCaseIntermediaryCode = user.intermediaryCode?.toLocaleLowerCase();
      const lowerCaseSearchTerm = userSearchTerm.toLocaleLowerCase();
      return (
        lowerCaseFirstName?.includes(lowerCaseSearchTerm) ||
        lowerCaseSurname?.includes(lowerCaseSearchTerm) ||
        lowerCaseIntermediaryCode?.toLocaleLowerCase().includes(lowerCaseSearchTerm)
      );
    });
    return searchedIntermediaries ?? [];
  };

  return (
    <ProfileExpandingMenu
      isOpen={actingAsSearchOpen}
      onExpandClick={() => {
        setActingAsSearchOpen(!actingAsSearchOpen);
      }}
      isLoading={isLoading}
    >
      <Grid row>
        <Block sm={12}>
          <Search
            className={styles.noLgMargin}
            placeholder='Search intermediary code or name'
            size={Search.SIZE.SMALL}
            onChange={(term) => setUserSearchTerm(term)}
          />
        </Block>
      </Grid>
      <SearchResultHeader resultCount={getSearchedUsers().length} />
      {getSearchedUsers().length > 0 && (
        <div className={styles.searchResults}>
          {getSearchedUsers().map((user) => (
            <UserContextCard
              userCode={user.intermediaryCode}
              firstName={user.firstName}
              surname={user.lastName}
              key={user.intermediaryCode}
              isSelected={isSelected(user)}
              selectUser={() => {
                if (!isSelected(user)) {
                  setSelectedUser(user);
                  setUserSearchTerm(undefined);
                  setActingAsSearchOpen(false);
                }
              }}
            />
          ))}
        </div>
      )}
    </ProfileExpandingMenu>
  );
};
